import { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { AuthContext } from "./AuthContext";

export default function ProtectedRoute({ children }) {
    const { currentUser } = useContext(AuthContext);
    const { pathname } = useLocation();

    /* Rutas públicas cuando NO hay usuario */
    const publicPaths = ["/", "/login"];
    const isWelcomePath = pathname.startsWith("/welcome");

    // ───────── visitante ─────────
    if (!currentUser) {
        const isAllowed =
            publicPaths.includes(pathname) || isWelcomePath;

        return isAllowed
            ? children                              // deja pasar a /, /login y /welcome/*
            : <Navigate to="/login" replace state={{ from: pathname }} />;
    }

    // ───────── usuario logueado ─────────
    return children;                            // acceso total
}
